import React from 'react';
import type { SpecificationViewModel } from '@api/enterprise/openapi/models/specification-view-model';
import BasicReadingForm from './BasicReadingForm';
import { useBasicReading, useInitializeTestPoints } from './hooks';
import type { BasicReadingTestData } from './types';

type Props = {
  testData?: BasicReadingTestData;
  specifications?: SpecificationViewModel[];
  onSave?: (data: BasicReadingTestData) => void;
  isReadOnly?: boolean;
};

const BasicReadingTest: React.FC<Props> = ({
  testData,
  specifications = [],
  onSave,
  isReadOnly = false
}) => {
  const initialPoints = useInitializeTestPoints(
    specifications,
    testData?.testPoints ?? []
  );

  const { testPoints, addTestPoint, deleteTestPoint, updateTestPoint } =
    useBasicReading(initialPoints, onSave);

  return (
    <BasicReadingForm
      testPoints={testPoints}
      onAddTestPoint={addTestPoint}
      onDeleteTestPoint={deleteTestPoint}
      onUpdateTestPoint={updateTestPoint}
      isReadOnly={isReadOnly}
    />
  );
};

export default BasicReadingTest;
